import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { clearData, createData } from "./create-object";
import { Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import * as fromApp from "../../../store/app.reducer";
import * as AssignmentsActions from '../store/assignments.actions';
import { CustomerModel } from "../../../models/customer.model";
import { selectStep } from "../store/assignment.selector";
import { NavigationStateService } from 'src/app/service/navigation-state.service';

@Component({
    selector: 'app-create-assignment',
    templateUrl: './create-assignment.component.html',
    styleUrls: ['./create-assignment.component.scss'],
    standalone: false
})
export class CreateAssignmentComponent implements OnInit, OnDestroy, AfterViewInit {

    steps = [
        {
            id: 1,
            route: '/components/assignments/create-assignment/step1',
            active: true,
            iconNotActiveSrc: '/assets/img/buildings 1.svg',
            iconActiveSrc: '/assets/img/buildings 1.svg'
        },
        {
            id: 2,
            route: '/components/assignments/create-assignment/step2',
            active: false,
            iconNotActiveSrc: '/assets/img/single-neutral-actions-shield 1.svg',
            iconActiveSrc: '/assets/img/single-neutral-actions-shield 1 active (1).svg'
        },
        {
            id: 3,
            route: '/components/assignments/create-assignment/step3',
            active: false,
            iconNotActiveSrc: '/assets/img/calendar 1.svg',
            iconActiveSrc: '/assets/img/calendar 1 active (1).svg'
        },
        {
            id: 4,
            route: '/components/assignments/create-assignment/step4',
            active: false,
            iconNotActiveSrc: '/assets/img/task-list-text-1 1.svg',
            iconActiveSrc: '/assets/img/task-list-text-active.svg'
        },
        {
            id: 5,
            route: '/components/assignments/create-assignment/step5',
            active: false,
            iconNotActiveSrc: '/assets/img/shield-unlock 1.svg',
            iconActiveSrc: '/assets/img/shield-unlock-active.svg'
        },
        {
            id: 7,
            route: '/components/assignments/create-assignment/step7',
            active: false,
            iconNotActiveSrc: '/assets/img/check-circle 1.svg',
            iconActiveSrc: '/assets/img/check-circle 1 active.svg'
        },
        {
            id: 8,
            route: '/components/assignments/create-assignment/step8',
            active: false,
            iconNotActiveSrc: '/assets/img/single-neutral-actions-shield 1.svg',
            iconActiveSrc: '/assets/img/single-neutral-actions-shield 1 active (1).svg'
        },
    ];

    public subscription: Subscription;
    public customer: CustomerModel;
    public step: number = 1;
    private authSubscription: Subscription;
    private stepSubscription: Subscription;

    constructor(public router: Router,
        private cd: ChangeDetectorRef,
        private store: Store<fromApp.AppState>,
        private navState: NavigationStateService) {
    }

    ngOnInit(): void {
        this.authSubscription = this.store.select(state => state.auth).subscribe(
            (auth) => {
                this.customer = auth.customer;
            });
        this.stepSubscription = this.store.pipe(select(selectStep)).subscribe(stepNumber => {
            if (stepNumber !== this.step) {
                Promise.resolve().then(() => {
                    this.step = stepNumber;
                    this.onSelectedStep();
                    this.cd.markForCheck();
                });
            }
        });

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                Promise.resolve().then(() => {
                    if (event.url.includes('step1') && this.step !== 1) {
                        this.step = 1;
                        this.cd.markForCheck();
                    } else if (event.url.includes('step2') && this.step !== 2) {
                        this.step = 2;
                        this.cd.markForCheck();
                    } else if (event.url.includes('step3') && this.step !== 3) {
                        this.step = 3;
                        this.cd.markForCheck();
                    }
                });
            }
        });
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        this.stepSubscription.unsubscribe();
        this.authSubscription.unsubscribe();
        this.store.dispatch(new AssignmentsActions.UpdateStep(1));
        clearData();
    }

    onSelectedStep() {
        this.steps = this.steps.map(x => {
            x.active = x.id <= this.step;
            if (x.id == this.step) this.router.navigate([x.route]);
            return x;
        })
    }

    public onBack(): void {
        if (this.step > 1) {
            const stepToGoBack = this.step - 1;
            // ✅ mark as internal back
            this.navState.setInternalBack(true);

            // Update step in store
            this.store.dispatch(new AssignmentsActions.UpdateStep(stepToGoBack));

            // Navigate directly to ensure it works in production
            const targetStep = this.steps.find(s => s.id === stepToGoBack);
            if (targetStep) {
                this.router.navigate([targetStep.route]).catch(err => {
                    console.error('Navigation error:', err);
                });
            }
        } else {
            this.navState.setBackNavigation(true);

            this.router.navigate(['/components/assignments']).then(() => {
                setTimeout(() => {
                    this.navState.setBackNavigation(false);
                }, 300);
            });

            localStorage.removeItem('selectedCategoryId');
        }
    }

    public onSaveAsDraft(): void {
        this.store.select(state => state.assignments)
            .subscribe(assignmentsStore => {
                if (assignmentsStore.isAssignmentCreatingFromHistory) {
                    createData.id = assignmentsStore.assignment.id;
                }
                this.store.dispatch(new AssignmentsActions.AddAssignmentAsDraft({
                    customerId: this.customer.id,
                    data: createData,
                }));
            })
            .unsubscribe();
    }

    public onCloseForm(): void {
        Object.keys(createData).forEach(key => delete createData[key]);
        this.router.navigate(['/components/assignments']);
        localStorage.removeItem('selectedCategoryId');
        localStorage.removeItem('selectedUniform');
    }

    isStep2Complete(): boolean {
        return !!createData.uniformId && !!createData.skillId;
    }
}